export default {
  data() {
    return {
      searchSchema: [
        {
          itemName: 'companyName',
          label: '企业名称',
          allowClear: true,
          type: 'input',
        },
        {
          itemName: 'companyCode',
          label: '企业ID',
          allowClear: true,
          type: 'input',
        },
        {
          itemName: 'bpmId',
          label: '申请流水号',
          allowClear: true,
          type: 'input',
        },
        {
          itemName: 'username',
          label: '申请人',
          type: 'input',
          allowClear: true,
        },
        {
          itemName: 'applyRangeDate',
          label: '申请日期',
          type: 'rangePicker',
          allowClear: true,
        },
        {
          itemName: 'approveRangeDate',
          label: '审批日期',
          type: 'rangePicker',
          allowClear: true,
        },
        {
          itemName: 'status',
          label: '审批状态',
          allowClear: true,
          type: 'select',
          selectList: [
            {
              text: '待审批',
              value: 1,
            },
            {
              text: '审批通过',
              value: 2,
            },
            {
              text: '审批不通过',
              value: 3,
            },
          ],
        },
        {
          itemName: 'bookType',
          label: '保证书类型',
          type: 'select',
          allowClear: true,
          selectList: [
            {
              text: '个人担保',
              value: 1,
            },
            {
              text: '第三方公司担保',
              value: 2,
            },
            {
              text: '关联公司互保',
              value: 3,
            },
          ],
        },
      ],
      searchData: {
        companyName: '',
        companyCode: '',
        bpmId: '',
        bookType: '',
        status: '',
        approveRangeDate: [],
        applyRangeDate: [],
        username: '',
      },
      columns: [
        {
          title: '序号',
          width: 70,
          dataIndex: 'order',
          fixed: 'left',
          align: 'center',
          slots: { title: 'customTitile' },
          customRender: (text, record, index) =>
            (this.pageData.current - 1) * this.pageData.pageSize + (index + 1),
          // scopedSlots: { customRender: 'order'}
        },
        {
          title: '申请流水号',
          dataIndex: 'bpmId',
          width: 250,
        },
        {
          title: '申请人',
          dataIndex: 'applier',
          width: 150,
        },
        {
          title: '企业ID',
          dataIndex: 'companyCode',
          width: 250,
        },
        {
          title: '企业名称',
          dataIndex: 'companyName',
          width: 150,
        },

        {
          title: '申请日期',
          dataIndex: 'applyDate',
          width: 150,
        },
        {
          title: '审批日期',
          dataIndex: 'approveDate',
          width: 150,
        },
        {
          title: '审批状态',
          dataIndex: 'statusStr',
          width: 150,
        },
        {
          title: '文件编号',
          dataIndex: 'code',
          width: 150,
        },
        {
          title: '文件名称',
          dataIndex: 'fileName',
          width: 150,
        },
        {
          title: '担保类型',
          dataIndex: 'typeStr',
          width: 150,
        },
        {
          title: '保证书类型',
          dataIndex: 'bookTypeStr',
          width: 150,
        },
        {
          title: '担保方名称',
          dataIndex: 'assuranceName',
          width: 150,
        },
        {
          title: '担保个人身份',
          dataIndex: 'identityStr',
          width: 150,
        },
        {
          title: '上市公司',
          dataIndex: 'isListedStr',
          width: 150,
        },
        {
          title: '上市公司担保公告',
          dataIndex: 'assureNoticeStr',
          width: 150,
        },
        {
          title: '书面担保金额',
          scopedSlots: { customRender: 'writtenAmount' },
          dataIndex: 'writtenAmount',
          width: 150,
        },
        {
          title: '有效担保金额',
          scopedSlots: { customRender: 'validAmount' },
          dataIndex: 'validAmount',
          width: 150,
        },
        {
          title: '货币',
          dataIndex: 'currencyUnitStr',
          width: 150,
        },
        {
          title: '担保生效日期',
          dataIndex: 'efficientDate',
          width: 150,
        },
        {
          title: '担保到期日期',
          dataIndex: 'expireDate',
          width: 150,
        },
        {
          title: '操作',
          fixed: 'right',
          width: 200,
          dataIndex: 'action',
          slotName: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
    }
  },
  methods: {
    // 查询
    handleSearch(data) {
      this.searchData = { ...this.searchData, ...data }
      this.pageData.current = 1
      this._getTableData()
    },
    // 点击分页按钮
    handleClickPage({ current, pageSize }) {
      this.pageData = { ...this.pageData, current, pageSize }
      this._getTableData()
    },
    transLabelToName(label) {
      switch (label) {
        case 'assuranceName':
          return '担保方名称'
        case 'assureNoticeStr':
          return '上市公司担保公告'
        case 'bookTypeStr':
          return '担保-保证书类型'
        case 'code':
          return '文件编号'
        case 'fileName':
          return '文件名称'
        case 'identityStr':
          return '担保个人身份'
        case 'isListedStr':
          return '上市公司'
        case 'writtenAmount':
          return '书面担保金额'
        case 'validAmount':
          return '有效担保金额'
        case 'efficientDate':
          return '担保生效日期'
        case 'expireDate':
          return '担保到期日期'
        case 'currencyUnitStr':
          return '货币'
        case 'remark':
          return '备注'
      }
    },
  },
}
